<div class="flex f-fd--column">
  <div>
    <howden-page-title></howden-page-title>
  </div>
  <div class="f-basis--2 flex f-ai--center f-gap--10px">
    <button mat-raised-button color="primary"  (click)="openClientsSearchDialog()">
      <mat-icon>person_search</mat-icon>
      <span i18n="@@client.search.buttom.search-client">Buscar Cliente</span>
    </button>
  </div>
</div>